module.exports = __webpack_public_path__ + "img/nothing-applications.d6fd3364.svg";